import React from 'react'
import Link from '../navigation/Link'
import ListModule from '../module/ListModule'
import { textOperators, equalityOperators, multiselectOperators, dateOperators } from '../../utils/constants/operators'
import { payment_method } from '../../utils/constants/misc'

const PaymentSubModule = ({ userRight, user, location }) => {
  const customerId = location?.state?.id ?? null

  const options = {
    objectType: 'incomes',
    accessRight: userRight,
    paperStyle: {},
    objectFilter: () => ({ company_id: user.company_id, customer_id: customerId }),
    actions: { go: true },
    showTotal: { display: true, label: 'Montant total', field: 'totalAmount', type: 'currency' },
    isExpand: false,
    columns: [
      { name: 'periodYear', label: 'Année', isFilter: true, operators: dateOperators },
      { name: 'periodMonth', label: 'Mois', isFilter: true, operators: textOperators },
      { name: 'periodYearMonth', label: 'Période', isFilter: true, operators: textOperators },
      {
        name: 'date',
        label: 'Date',
        inputType: 'date',
        type: 'date',
        format: 'DD/MM/YYYY',
        isFilter: true,
        operators: dateOperators
      },
      {
        name: 'invoice.invoice_number',
        label: 'N° Facture',
        isFilter: true,
        operators: textOperators,
        mapping: (id, rowid) => (
          <Link to={`/invoices/view`} state={{ id: rowid.invoice?.id, history: '/customers/view' }}>
            {id}
          </Link>
        )
      },
      { name: 'amount', label: 'Montant', type: 'currency', isFilter: false },
      { name: 'description', label: 'Description', isFilter: false },
      {
        name: 'payment_method',
        label: 'Méthode payement',
        isFilter: true,
        values: payment_method,
        valueEditorType: 'multiselect',
        operators: [...equalityOperators, ...multiselectOperators],
        mapping: (name) => {
          const result = payment_method.find((item) => item.name === name?.toString())
          return result ? result.label : name
        }
      }
    ]
  }

  const toolbar = {
    isFilter: true,
    columns: options.columns,
    isSubMod: true,
    style: { marginTop: '5px', marginBottom: '5px' },
    objectType: 'incomes',
    accessRight: userRight,
    actions: { addFor: true },
    getContext: () => ({ customer_id: customerId }),
    columnVisibility: true
  }

  return <ListModule options={options} toolbar={toolbar} />
}

export default React.memo(PaymentSubModule)
